import { Component, output, signal, ViewChild } from '@angular/core';
import {
  SynButtonComponent,
  SynDialogComponent,
  SynergyFormsModule,
  SynIconComponent,
  SynInputComponent, SynOptionComponent,
} from '@synergy-design-system/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { KeyValue } from '../../types';

@Component({
  selector: 'app-add-attribute-dialog',
  template: `
    <syn-dialog #addAttributeDialog label="Add Attribute" i18n-label="@@add-attribute">
      @if (active()) {
        <form #form=ngForm (submit)="addAttribute()" class="flex-col gap-1">
          <syn-combobox [(ngModel)]="attributeKey" [required]="true"
                        [maxlength]="200" [minlength]="1"
                        name="attributeKey"
                        label="Attribute Key" i18n-label="@@attribute-key"
          >
            <syn-option>y_CustomerNumber</syn-option>
            <syn-option>y_CustomerName</syn-option>
            <syn-option>y_SSUCode</syn-option>
          </syn-combobox>
          <syn-input [(ngModel)]="attributeValue" [required]="true"
                     [maxlength]="200" [minlength]="1"
                     name="attributeValue"
                     label="Attribute Value" i18n-label="@@attribute-value"
          />
        </form>

        <syn-button slot="footer" (click)="hide()">
          <syn-icon name="close_fill" slot="prefix" />
          <span i18n="@@cancel">Cancel</span>
        </syn-button>
        <syn-button slot="footer" variant="filled" (click)="addAttribute()" [disabled]="form.invalid!">
          <syn-icon name="add_fill" slot="prefix" />
          <span i18n="@@add-attribute">Add Attribute</span>
        </syn-button>
      }
    </syn-dialog>
  `,
  styles: [],
  imports: [
    SynButtonComponent,
    SynIconComponent,
    SynDialogComponent,
    FormsModule,
    ReactiveFormsModule,
    SynButtonComponent,
    SynDialogComponent,
    SynIconComponent,
    SynInputComponent,
    SynergyFormsModule,
    SynOptionComponent,
  ],
})
export class AddAttributeDialogComponent {
  attributeKey = signal('');
  attributeValue = signal('');
  active = signal(false);

  add = output<KeyValue>();

  @ViewChild(SynDialogComponent) dialog!: SynDialogComponent;

  public show() {
    void this.dialog.nativeElement.show();
    this.active.set(true);
  }

  public hide() {
    void this.dialog.nativeElement.hide();
    this.attributeKey.set('');
    this.attributeValue.set('');
    this.active.set(false);
  }

  addAttribute() {
    const key = this.attributeKey();
    const value = this.attributeValue();
    if (key.length === 0 || value.length === 0) {
      return;
    }
    this.add.emit({ key: this.attributeKey(), value: this.attributeValue() });

    this.hide();
  }
}
